export const PHONE_LAYOUT_CONTAINER_ID = 'phone-layout-container' as const;
